export enum NotificationType {
  PlanCloneCompleted = 'STRATEGY_PLAN_CLONE_COMPLETED',
  // A recompute of the user's chart numbers ended: { chartId, status: 'READY' | 'FAILED' }
  ChartDataUpdated = 'CHART_DATA_UPDATED'
}
